import { useState } from "react";
import DeleteDialog from "../../../components/DeleteDialog";
import { mensagemDeErro, respostaOk } from "../../../../utils/resposta";

/**
 * Confirmação de exclusão de um item de conteúdo. `excluir(id)` devolve a
 * resposta do axios; em caso de erro (ex.: bioma ligado a espécies) mostra a
 * mensagem do backend no próprio diálogo.
 */
export default function Exclusao({ titulo, subtitulo, item, excluir, onExcluido, onCancelar, textoBotao = "Excluir" }) {
  const [erro, setErro] = useState("");

  async function confirmar() {
    const resultado = await excluir(item.id);
    if (!respostaOk(resultado)) {
      setErro(resultado?.response?.data?.error || mensagemDeErro(resultado));
      return;
    }
    onExcluido();
  }

  return (
    <DeleteDialog titulo={titulo} subtitulo={subtitulo} error={erro} textButton={textoBotao} onDelete={confirmar} onClose={onCancelar} />
  );
}
